export const addElementIfNotExists = (array: any[], elem: any) => {
  if (Array.isArray(array) && elem && array.indexOf(elem) < 0) {
    array.push(elem);
  }
  return array;
};

/**
 * Retrieves a specified number of values from a string based on the start index.
 *
 * @param inputString - The input string containing comma-separated values.
 * @param startIndex - The index from which to start retrieving values.
 * @param totalValues - The total number of values to retrieve.
 * @returns A string containing the retrieved values.
 */
export const getValuesFromIndex = (
  inputString: string,
  startIndex: number,
  totalValues: number
) => {
  // Splitting the string into an array
  const valuesArray = inputString?.split(',');

  // Slicing the array to get the required values
  const slicedValues = valuesArray?.slice(startIndex, startIndex + totalValues);

  // Joining the sliced values back into a string
  return slicedValues?.join(',');
};
